import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "abm_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ accepted_at: new Date().toISOString() })); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[9998] bg-white border border-border rounded-md shadow-2xl p-5"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
          <Cookie className="w-4 h-4 text-primary" strokeWidth={1.5} />
        </span>
        <div className="flex-1 min-w-0">
          <div className="font-serif-heading text-lg leading-tight">Solo cookie tecnici</div>
          <p className="text-xs text-neutral-600 mt-1.5">
            Usiamo esclusivamente cookie tecnici necessari al funzionamento dell'app (autenticazione, sessione).
            Nessun tracking, nessuna profilazione.{" "}
            <Link to="/cookie" className="text-primary underline hover:no-underline">Leggi la cookie policy</Link>.
          </p>
        </div>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 -mt-1 -mr-1 w-7 h-7 rounded-full hover:bg-neutral-100 flex items-center justify-center text-neutral-400"
          aria-label="Chiudi"
          data-testid="cookie-banner-close"
        >
          <X className="w-4 h-4" strokeWidth={1.5} />
        </button>
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={accept}
          className="px-5 h-9 rounded-full bg-neutral-900 hover:bg-neutral-800 text-white text-sm font-medium transition-colors"
          data-testid="cookie-banner-ok"
        >
          OK, ho capito
        </button>
      </div>
    </div>
  );
}
